module.exports = __webpack_public_path__ + "static/media/apac-flag.69b81a7a.svg";